import {Breakpoints, CTA, styled} from '@volkswagen-onehub/components-core';
import {InputHide, InputShow} from '@volkswagen-onehub/icons-core';
import React, {useContext} from 'react';
import {ResponseVehicle} from '../../../types/api';
import {VisualToggleContext} from '../../../context/modules/dimensions/VisualToggleContext';
import useTrans from '../../../hooks/use-trans';
import { TrackingEvents } from '../../../types/enums/tracking-events.enum';
import { useFeatureServices } from '../../../use-feature-services';

const VisualToggleContainer = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;

  @media (min-width: ${Breakpoints.b560}px) {
    opacity: 0;
  }
`;

const VisualToggle: React.FC<{
  vehicle: ResponseVehicle;
}> = ({vehicle}) => {
  const {
    aria: {length}
  } = useTrans();

  const { tracking } = useFeatureServices();
  const visualToggleCtx = useContext(VisualToggleContext);

  const onVisualToggle = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation();

    const exterior = vehicle?.exterior_colors?.[0];
    const visible = visualToggleCtx?.acodes.includes(vehicle.acode);

    tracking.track(TrackingEvents.VEHICLEBUTTON_CLICK, {
      eventInfo: {
        eventAction: TrackingEvents.VEHICLEBUTTON_CLICK,
        contentId: visible ? "show vehicle" : "hide vehicle"
      },
      environment: {
        featureAppId: 'CompareDimensionsWidget-D6-CA',
        featureAppIdAppVersion: '1.0',
      },
      personalization: {
        status: false,
      },
      configuration: {
        CarlineId: vehicle?.carline_id,
        CarlineName: vehicle.model,
        ModelId: vehicle?.sales_code,
        ModelName: vehicle.trim,
        ModelYear: vehicle.year.toString(),
        ExteriorColorCode: exterior ? exterior?.hex_code : null,
        ExteriorColorName: exterior ? exterior?.label : null,
        PriceTotalTotal: vehicle.msrp
      },
      link: {
        name: vehicle.model + (!visible ? ' hide' : ' show') + ' image  - Link',
        url: window.location.href
      }
    });

    visualToggleCtx?.set(vehicle.acode);
  };

  return (
    <VisualToggleContainer id="jelly-toggle">
      <CTA
        tag="button"
        emphasis="none"
        size="small"
        aria-label={
          (visualToggleCtx?.acodes.includes(vehicle.acode)
            ? length.toggle.show
            : length.toggle.hide)}
        onClick={onVisualToggle}
        icon={
          !visualToggleCtx?.acodes.includes(vehicle.acode)
          ? <InputHide aria-hidden="true" />
          : <InputShow aria-hidden="true" />
        }
      />
    </VisualToggleContainer>
  );
};

export default VisualToggle;
